<template>
    <b-row>
        <b-col cols="12">
            <h4>Monthly Active Report</h4>
        </b-col>
        <identity-iq-component :data="iqScore"></identity-iq-component>
        <myscore-iq-component :data="iqScore"></myscore-iq-component>
        <smart-credit-component :data="iqScore"></smart-credit-component>
    </b-row>
</template>
<script>
import IdentityIqComponent from './IQandScore/IdentityIqComponent.vue'
import MyscoreIqComponent from './IQandScore/MyscoreIqComponent.vue'
import SmartCreditComponent from './IQandScore/SmartCreditComponent.vue'
import axios from 'axios'
import {
    BRow,
    BCol,
} from 'bootstrap-vue-3'
export default {
    components: {
        BRow,
        BCol,
        IdentityIqComponent,
        MyscoreIqComponent,
        SmartCreditComponent
    },
    name:"ActiveReport",
    data() {
        return{
            iqScore:{}
        }
    },
    created(){
    this.getActiveReports();
    },
    methods: {
        getActiveReports() {
            const route = this.$router.resolve(
                {
                    name: 'admin-getactiveiqcredit',
                }
            );
            axios.get(route.href).then(({data})=>{
                let activeReport = data.data;
                this.iqScore = activeReport;
            }).catch()
        }
    }
}
</script>
